import moment from 'moment'
import { CampaignDefinition, CampaignConfirmationState } from './CampaignModalSkeleton.types'

export function createDefaultConfirmation(
	availableOrderTypes: string[],
	definition: CampaignDefinition<any>,
): CampaignConfirmationState {
	const defaultStartTime = moment().add(30, 'minutes')
	return {
		name: '',
		image: null,
		startDate: moment().toDate(),
		endDate: moment().add(1, 'day').toDate(),
		startTime: defaultStartTime.format('HH:mm'),
		endTime: '23:59',
		orderTypes: definition.forceDeliveryOrderType
			? ['delivery']
			: [...availableOrderTypes],
		hasLimit: definition.confirmationLimitPolicy === 'required',
		limit: definition.confirmationLimitPolicy === 'required' ? 1 : null,
		isPermanent: false,
	}
}

export function confirmationFromCampaign(
	campaign: any,
	availableOrderTypes: string[],
	definition: CampaignDefinition<any>,
): CampaignConfirmationState {
	const defaultStartTime = moment().add(30, 'minutes')
	const config = campaign.config ?? {}
	const campaignOrderTypes = config.orderTypes ?? campaign.orderTypes ?? []
	const initialOrderTypes =
		campaignOrderTypes.length > 0 ? campaignOrderTypes : availableOrderTypes

	const isPermanent =
		definition.allowsPermanent && !campaign.dateEnd

	const imageUrl = config.imageUrl
	const image =
		typeof imageUrl === 'string' && imageUrl.trim()
			? imageUrl.trim()
			: null

	return {
		name: config.campaignName ?? '',
		image,
		startDate: campaign.dateStart
			? moment(campaign.dateStart).toDate()
			: moment().toDate(),
		endDate: campaign.dateEnd
			? moment(campaign.dateEnd).toDate()
			: moment().add(1, 'day').toDate(),
		startTime: campaign.dateStart
			? moment(campaign.dateStart).format('HH:mm')
			: defaultStartTime.format('HH:mm'),
		endTime: campaign.dateEnd
			? moment(campaign.dateEnd).format('HH:mm')
			: '23:59',
		orderTypes: definition.forceDeliveryOrderType
			? ['delivery']
			: initialOrderTypes,
		hasLimit:
			definition.confirmationLimitPolicy === 'required'
				? true
				: Boolean(config.limit),
		limit: config.limit ?? null,
		isPermanent,
	}
}

export function hasRequiredCampaignNaming({
	supportsCampaignNaming,
	isUpdate,
	existingName,
	existingImage,
	currentName,
	currentImage,
}: {
	supportsCampaignNaming?: boolean
	isUpdate?: boolean
	existingName?: unknown
	existingImage?: unknown
	currentName?: unknown
	currentImage?: unknown
}): boolean {
	if (!supportsCampaignNaming) {
		return true
	}

	const normalizedCurrentName = String(currentName ?? '').trim()
	const normalizedExistingName = String(existingName ?? '').trim()
	const hasCurrentValue = Boolean(normalizedCurrentName) || Boolean(currentImage)
	const hadExistingValue = Boolean(normalizedExistingName) || Boolean(existingImage)

	if (!isUpdate) {
		return Boolean(normalizedCurrentName) && Boolean(currentImage)
	}

	if (!hasCurrentValue && !hadExistingValue) {
		return true
	}

	return Boolean(normalizedCurrentName) && Boolean(currentImage)
}

export function normalizeShopIds(shopIds: unknown): string[] {
	if (Array.isArray(shopIds)) {
		return shopIds as string[]
	}
	if (shopIds && typeof shopIds === 'object') {
		return Object.keys(shopIds as Record<string, unknown>)
	}
	return []
}
